import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export default function Portal({
  children,
  id,
  className,
}: {
  children: ReactNode;
  id?: string;
  className?: string;
}) {
  return createPortal(<>{children}</>, document.body);
}
